export const getVideoStructuredData = ({ videos, productLabel } = {}) => {
  return {
    '@context': 'https://schema.org',
    '@graph': videos && videos.map(({ thumbnail, videoStill, shortDescription, url }) => ({
      '@type': 'VideoObject',
      name: productLabel,
      description: shortDescription,
      thumbnailUrl: [thumbnail || videoStill],
      contentUrl: url,
    }))
  };
};
